/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  PolicyListsService,
  IPolicyListsMethods,
  IUpdateStatusMethods,
  UpdateStatusService,
  LoadingService,
  ILoadingMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IResendCredentialMethods,
  ResendCredentialService,
  IEventDetailMethods,
  EventDetailService,
  IButtonMethods,
  ButtonService,
  IEventTimelineMethods,
  EventTimelineService
} from "./components";

export type PayoutListPageAgent = IHeaderMethods &
  ISettingsMethods &
  IPolicyListsMethods &
  IUpdateStatusMethods &
  IStaticPageContentMethods &
  IResendCredentialMethods &
  ILoadingMethods &
  IEventDetailMethods &
  IButtonMethods &
  IEventTimelineMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new PolicyListsService(),
    new UpdateStatusService(),
    new LoadingService(),
    new StaticPageContentService(),
    new ResendCredentialService(),
    new EventDetailService(),
    new ButtonService(),
    new EventTimelineService(),
  ];
};

export const getAgent = () => {
  return createAgent<PayoutListPageAgent>({
    plugins: getPlugins(),
  });
};
